module.exports = __webpack_public_path__ + "img/Jump Casting24.eb887040.jpg";